import Chatbot from "./components/Chatbot";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing        from "./pages/Landing";
import Login          from "./pages/Login";
import Signup         from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword  from "./pages/ResetPassword";
import Dashboard      from "./pages/Dashboard";
import Payment        from "./pages/Payment";
import FreeLead       from "./pages/FreeLead";
import Search         from "./pages/Search";
import CRM            from "./pages/CRM";
import Admin          from "./pages/Admin";
import CustomerFinder from "./pages/CustomerFinder";
import AutoSetup      from "./pages/AutoSetup";
import Referral       from "./pages/Referral";
import Reseller       from "./pages/Reseller";

function Private({ children }) {
  return localStorage.getItem("token") ? children : <Navigate to="/login" />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                element={<Landing />} />
        <Route path="/login"           element={<Login />} />
        <Route path="/signup"          element={<Signup />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/free-lead"       element={<Private><FreeLead /></Private>} />
        <Route path="/payment"         element={<Private><Payment /></Private>} />
        <Route path="/dashboard"       element={<Private><Dashboard /></Private>} />
        <Route path="/search"          element={<Private><Search /></Private>} />
        <Route path="/crm"             element={<Private><CRM /></Private>} />
        <Route path="/auto-setup"      element={<Private><AutoSetup /></Private>} />
        <Route path="/referral"        element={<Private><Referral /></Private>} />
        <Route path="/reseller"        element={<Private><Reseller /></Private>} />
        <Route path="/customer-finder" element={<Private><CustomerFinder /></Private>} />
        <Route path="/admin"           element={<Admin />} />
      </Routes>
      <Chatbot />
    </BrowserRouter>
  );
}
// Wed Apr 22 05:58:46 IST 2026
